
// IIFE - Immediately Invoked Function Expression
(function (library)
{
    library(window.jQuery, window, document);
}(function ($, window, document)
{

  //------------------------------------------------------------------------------------------------------------------
  // --- Functions
  //------------------------------------------------------------------------------------------------------------------
  var initJotForm = function(){

    $(document).on('click', '[data-modal-jotform]', (e) => {

      var $self = $(e.currentTarget);
      var href = $self.attr("href");

      //TODO: Open jotform in fancybox
      //return false;
    });

  }

  //------------------------------------------------------------------------------------------------------------------
  // --- Functions
  //------------------------------------------------------------------------------------------------------------------
  var init = () => {

    initJotForm();

  };
  window.initSite = init;


  //------------------------------------------------------------------------------------------------------------------
  // --- Page Ready (DOM)
  //------------------------------------------------------------------------------------------------------------------
  $(function () {

      var siteInit = function () {

        init();

      }();
  });

}));